import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "./api";
import {handleResponseStatus} from "./utils";

const initialState = {
    items: '',
    importCsvStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    exportCsvStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    error: null
};


//Export CSV file
export const exportCsvFile = createAsyncThunk('export/exportCsvFile', async ({roleSign, ttid}) => {
    try {
        let response = await api.get(`/${roleSign}/restaurentProductTemplate/exportProduct?ttid=${ttid}`);
        return {...response};
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

//Import CSV file
export const importCsvFile = createAsyncThunk('import/importCsvFile', async ({roleSign, data}) => {
    try {
        const response = await api.post(`${roleSign}/restaurentProductTemplate/importProduct`, data, {
            useMultipart: true,
        });
        return {...response};
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

const importExportSlice = createSlice({
    name: "importExport",
    initialState,
    extraReducers: (builder) => {
        builder

            // Export CSV
            .addCase(exportCsvFile.pending, (state) => {
                state.exportCsvStatus = 'loading';
            })
            .addCase(exportCsvFile.fulfilled, (state, action) => {
                const {exportCsvStatus, error} = handleResponseStatus(action.payload, 'exportCsvStatus');
                state.items = exportCsvStatus === "success" ? action.payload.data : state.items;
                state.exportCsvStatus = exportCsvStatus;
                state.error = error;
            })
            .addCase(exportCsvFile.rejected, (state, action) => {
                state.exportCsvStatus = 'failed';
                state.error = action.error.message;
            })

            // Import CSV
            .addCase(importCsvFile.pending, (state) => {
                state.importCsvStatus = 'loading';
            })
            .addCase(importCsvFile.fulfilled, (state, action) => {
                const {importCsvStatus, error} = handleResponseStatus(action.payload, 'importCsvStatus');
                state.importCsvStatus = importCsvStatus;
                state.error = error;
            })
            .addCase(importCsvFile.rejected, (state, action) => {
                state.importCsvStatus = 'failed';
                state.error = action.error.message;
            })
    }
});

export default importExportSlice.reducer;
